import type { FaireProductEntity } from "../../entity_types/product";

export const p_dwfp2t9hhg: FaireProductEntity = {
  token: "p_dwfp2t9hhg",
  type: "product",
  name: "Mystery Keychains Bag",
  brandToken: "b_b703e67f",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/163bdbaecf29d6cb99b1b66b6c78bf841ef66e63c7d84080e4e10ca0f75992f6.png",
  galleryImageUrls: [],
  priceDollars: 13.86,
  description:
    "\nGet a bunch of keychains for a GREAT deal! Perfect for adding some variety to your assortment!\n\nEach bag contains a variety of keychains- some new, some old, some secret styles we brought back just for this product and are only available in mystery bags!\n\nEach pack will come with 10 keychains. Customization and requests not available for this product and this deal will only last as long as we have the inventory for it!\n",
  tags: [],
  msrpDollars: 27.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:28.516Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
